import localityModule from "./localityModule"
import localityView from "./localityView.html"

localityModule.config(["editionServiceProvider", (editionServiceProvider) => {
    editionServiceProvider.registerEdition("locality", localityView, "localityController")
}])